<template>
    <div>
    <div
      class="section1"
      id="intro"
      v-bind:style="{
        'background-image':
          'url(' +
          this.hst +
          'uploads/banners/' +
          page.page.img_full +
          ' )'
      }"
     v-if="$resize && $mq.above(767)"
    >
      <div class="section_wrapper clearfix">
        <div class="items_group clearfix" style="display: flex;">
          <div class="column one-second column_column">
      
          </div>
          <div class="column one-second column_column ">
            <!--
            <div class="title_full">
                <h2>Gas en casa</h2>
                <h4>siempre que lo necesites</h4>
            </div>
             -->
             <FormPedidos></FormPedidos>
          </div>
        </div>
      </div>
    </div>
    <div
      class="section1"
      id="intro"
      v-bind:style="{
        'background-image':
          'url(' + this.hst + 'uploads/banners/' + page.page.imga_responsive + ' )'
      }"
      v-else
    >
      <div class="section_wrapper clearfix">
        <div class="items_group clearfix">
          <div class="column one-second column_column">
            <div class="column_attr" style="padding: 0px">
            <!--
            <div class="title_resp">
              <h2>Gas en casa</h2>
              <h4>siempre que lo necesites</h4>
            </div>
            -->
             <FormPedidos></FormPedidos>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
import Page from "../point/Page.js";
import FormPedidos from './FormPedido.vue';

export default {
  components: { FormPedidos },
  data: function() {
    return {
      hst: hst,
      page: new Page(),
    };
  },
  mounted: function() {
    this.page.get_page();
  }
};
</script>
<style>
#intro {
  padding-top: 30px;
  padding-bottom: 80px;
}
.section1 {
  background-color: #05060d;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
@media screen and (max-width: 1024px) {
  .price {
    font-size: 28px;
  }
  a.price.tel_new {
    font-size: 18px !important;
  }
}
@media screen and (max-width: 768px) {
  .pp_pic_holder.pp_default {
    width: 100% !important;
  }
  .pp_content {
    width: 100% !important;
    height: 290px !important;
  }
  .pp_details {
    width: 100% !important;
    margin-top: -20px !important;
  }
  .ppt {
    display: none;
  }
  .section1 {
    background-color: #05060d;
    /*background-image: url("content/taxi/images/home_taxi_header.jpg");*/
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .price {
    font-size: 20px;
  }
  a.price.tel_new {
    font-size: 12px !important;
  }
  button#btn_pagar {
    padding: 3px 22px 8px !important;
    font-size: 12px;
  }
}
@media screen and (max-width: 425px) {
  #colum_form {
    border-radius: 20px 130px 20px 20px;
    background-color: #ffda4b;
  }
  a.price.tel_new {
    font-size: 20px !important;
  }
  .price {
    font-size: 33px;
  }
}
.oculto {
  display: none;
}
.mayusculas {
  text-transform: uppercase;
}
.title_resp{
  text-align: center;
 
}
.title_resp h2, h4{
  font-family: 'Roboto Slab', serif;
  color:#fff;
}

.title_resp h4{
  font-size: 20px;
}

.title_resp h2{ 
  margin-bottom: 25px;
  font-size: 50px;
}


.title_full{
  text-align: center;
 
}
.title_full h2, h4{
  font-family: 'Roboto Slab', serif;
  color:#fff;
}

.title_full h4{
  font-size: 28px;
}

.title_full h2{ 
  margin-bottom: 25px;
  font-size: 66px;
}
</style>



// WEBPACK FOOTER //
// ./src/components/Banner.vue